import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { convertEdgesToNodeMap, getUpdatedProperties } from "../modules/Utils";

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];
const VOID_FN = () => {};

const useStandardsTableProps = params => {
  const {
    columns = EMPTY_ARRAY,
    edges = EMPTY_ARRAY,
    properties = EMPTY_OBJECT,
    cellUtils = EMPTY_OBJECT,
    actionHandlerFn = VOID_FN,
  } = params;

  const { t } = useTranslation(["common", "scopeAndSequence", "course"]);

  const updatedProperties = useMemo(() => {
    return getUpdatedProperties({ t, properties });
  }, [properties, t]);

  const { nodeMap, sideNavData, originalNodeMap } = useMemo(() => {
    return convertEdgesToNodeMap({
      edges,
      columns,
      properties: updatedProperties,
      cellUtils,
      actionHandlerFn,
    });
  }, [cellUtils, columns, edges, updatedProperties, actionHandlerFn]);

  return {
    properties: updatedProperties,
    columns,
    nodeMap,
    actionHandlerFn,
    sideNavData,
    originalNodeMap,
  };
};

export default useStandardsTableProps;
